import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

export const GradientCard = ({ children, ...props }) => {
  const theme = useTheme();
  return (
    <Card
      {...props}
      sx={{
        background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.default, 0.95)} 100%)`,
        backdropFilter: 'blur(20px)',
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        borderRadius: 3,
        ...props.sx
      }}
    >
      {children}
    </Card>
  );
};

export const StatCard = ({ icon, label, value, color = 'primary', ...props }) => {
  const theme = useTheme();
  return (
    <GradientCard {...props} sx={{ height: '100%', ...props.sx }}>
      <CardContent sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              minWidth: 56,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${theme.palette[color].main} 0%, ${theme.palette[color].dark} 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
            }}
          >
            {icon}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ mb: 0.5 }}
            >
              {label}
            </Typography>
            <Typography 
              variant="h5" 
              sx={{ fontWeight: 700 }}
            >
              {value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </GradientCard>
  );
};